import {client} from '../helpers/api';

export async function postCheckPurchase({kidId, month}) {
  const body = {kid_id: kidId, month_number: month};

  const response = await client.post('/api/check-purchase', body);

  if (response.data?.status) {
    return response.data?.message || 'Success';
  } else if (response.data?.status === false) {
    throw response.data?.message || '';
  }
  throw response;
}
